import axios from "axios";
import { API_ADDRESS } from "../../constants/config";
import { TOKEN_DATA } from "../../constants/tokens";
import { multiply } from "../../utils/formatNumber";

export class TokenInfoService {
  public fetchTokenInfo = async (params) => {
    try {
      const { token } = params;
      const staticData = TOKEN_DATA[token];

      const contractData: any = axios.get(
        `${API_ADDRESS}/public/contract/info`
      );
      const priceData: any = axios.get(`${API_ADDRESS}/public/contract/price`);

      const [
        { data: contractResult },
        { data: priceResult },
      ] = await Promise.all([contractData, priceData]);

      const {
        name,
        address,
        symbol,
        decimals: precision,
        maximumSupply,
        circulatingSupply,
        circulatingSupplyInDecimal,
        activeSupply,
        quarantined,
        totalBurnt,
      } = contractResult[token];

      const { current } = priceResult;
      let price: any = 0;
      let marketCap: any = 0;
      if (typeof current === "object" && token === "rise") {
        price = current.priceInDecimal;
        marketCap = multiply(circulatingSupplyInDecimal, price);
      } else {
        price = "n/a";
        marketCap = "n/a";
      }

      const result = {
        name,
        address,
        symbol,
        precision,
        maximumSupply,
        circulatingSupply,
        activeSupply,
        quarantined,
        totalBurnt,
        price: price,
        marketCap: marketCap,
        ...staticData,
      };

      return result;
    } catch (e) {
      console.log(e);
      if (e.message) {
        throw e;
      }
      throw new Error("Error connecting to token service");
    }
  };
}
